import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const sessao = auth.session;

  // Usuário não autenticado
  if (!sessao?.accessToken) {
    return router.createUrlTree(['/login']);
  }

  // Tela de primeiro acesso
  if (state.url.split('?')[0] === '/primeiro-acesso') {
    if (sessao.primeiroAcesso === true) {
      return true;
    }

    return router.createUrlTree([
      sessao.perfil === 'ADMIN' ? '/admin/dashboard' : '/parceiro/dashboard',
    ]);
  }

  // Impede acessar o dashboard antes de trocar a senha
  if (sessao.primeiroAcesso === true) {
    return router.createUrlTree(['/primeiro-acesso']);
  }

  // Validação de perfil
  const roles = route.data?.['roles'] as string[] | undefined;

  if (roles?.length && !roles.includes(sessao.perfil)) {
    return router.createUrlTree([
      sessao.perfil === 'ADMIN' ? '/admin/dashboard' : '/parceiro/dashboard',
    ]);
  }

  return true;
};
